// instant.page-style navigation prefetch: the moment a pointer hovers (or a
// finger touches) an internal link, start fetching that page's HTML — by the
// time the click lands, the document is already in the prefetch cache. With
// fingerprinted assets cached immutably, the HTML is the only thing left to
// fetch, so navigation feels near-instant.
//
// Server-side page-view tracking ignores these (Sec-Purpose/Purpose headers —
// see PagesController), so prefetches never pollute the funnel.

const seen = new Set();

const prefetch = (url) => {
  if (seen.has(url)) return;
  seen.add(url);
  const link = document.createElement("link");
  link.rel = "prefetch";
  link.href = url;
  document.head.appendChild(link);
};

const handler = (event) => {
  const target = event.target;
  const a = target && target.closest ? target.closest("a[href]") : null;
  if (!a) return;
  if (a.origin !== window.location.origin) return;
  if (a.target === "_blank" || a.hasAttribute("download")) return;
  // Links that leave for another site through a redirect (the Swyvel renewal
  // invoice on Stripe) say so; prefetching them would call Stripe on hover.
  if (a.hasAttribute("data-no-prefetch")) return;
  const path = a.pathname;
  // Never touch auth, storage, or api endpoints; skip in-page anchors.
  if (path.startsWith("/users") || path.startsWith("/rails") || path.startsWith("/api")) return;
  if (a.href.split("#")[0] === window.location.href.split("#")[0]) return;
  prefetch(path + a.search);
};

if (typeof document !== "undefined") {
  document.addEventListener("mouseover", handler, { passive: true });
  document.addEventListener("touchstart", handler, { passive: true });
}
